import {Component, Input, OnInit, AfterViewInit} from '@angular/core';
import * as echarts from 'echarts';
import {ICRMTasksCalendarWidgetModel, WidgetModel} from '../../model/widget.model';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {AppTasksViewCalendarComponent} from './tasks-view-calendar/tasks-view-calendar.component';
import {IPeriodChart, WidgetTaskCalendarService} from '../../services/widget-task-calendar.service';
import {TranslateService} from '@ngx-translate/core';
import {TaskModel} from '../../../../models/task.model';

type TECharts = echarts.ECharts;
type TParamsCB = echarts.DefaultLabelFormatterCallbackParams
const DIALOG_VIEW_TASK_TABLE = {
    width: '80vw',
    minWidth: '50vw',
    maxWidth: '100%'
}

@Component({
    selector: 'app-crm-calendar-widget',
    templateUrl: './crm-calendar-widget.component.html',
    styleUrl: './crm-calendar-widget.component.scss'
})
export class AppCrmCalendarWidgetComponent implements OnInit, AfterViewInit {
    @Input() widgetData: WidgetModel;
    private widgetCalendar: ICRMTasksCalendarWidgetModel;
    private chartDom: HTMLElement;
    private myChart: TECharts;
    public periodChart: IPeriodChart;
    private weekDayAbbr: string [] = []
    private dialogViewTaskRef: MatDialogRef<AppTasksViewCalendarComponent>

    constructor(
        private taskCalendarService: WidgetTaskCalendarService,
        private dialog: MatDialog,
        private translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        [7, 1, 2, 3, 4, 5, 6, 7].forEach(el => this.weekDayAbbr.push(this.translate.instant('WIDGETS.CALENDAR_TASKS.DAYS.' + el)))
        this.periodChart = {
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear()
        }
        this.taskCalendarService.addInfoForTip = this.translate.instant('WIDGETS.CALENDAR_TASKS.LABEL.ADD_INFO')
        this.widgetCalendar = this.widgetData as unknown as ICRMTasksCalendarWidgetModel;
        this.taskCalendarService.prepareDataForChart(this.widgetCalendar, this.periodChart)
    }

    ngOnChanges(): void {
        if (this.widgetCalendar) {
            this.widgetCalendar = this.widgetData as unknown as ICRMTasksCalendarWidgetModel;
            this.taskCalendarService.prepareDataForChart(this.widgetCalendar, this.periodChart)
            this.myChart.setOption(this.taskCalendarService.setChartOptions(this.periodChart, this.weekDayAbbr), true)
        }
    }

    ngAfterViewInit(): void {
        this.chartInit();
        this.setChartEvents();
    }

    setChartEvents() {
        this.myChart.on('legendselectchanged', (params) => this.handleLabelChangeEvent(params as TParamsCB))
        this.myChart.on('click', (params) => this.handleDiagramClick(params as TParamsCB));
    }

    chartInit() {
        this.chartDom = document.getElementById('calendarChart')!;
        this.myChart = echarts.init(this.chartDom);
        this.myChart.setOption(this.taskCalendarService.setChartOptions(this.periodChart, this.weekDayAbbr), true)
    }

    changeMonth(step: number) {
        if ([13, 0].includes(this.periodChart.month + step)) {
            this.periodChart.month = step === 1 ? 1 : 12
            this.periodChart.year = this.periodChart.year + step
        } else {
            this.periodChart.month = this.periodChart.month + step
        }
        this.taskCalendarService.prepareDataForChart(this.widgetCalendar, this.periodChart)
        this.myChart.setOption(this.taskCalendarService.setChartOptions(this.periodChart, this.weekDayAbbr), true)
    }

    handleLabelChangeEvent(params: TParamsCB) {
        let taskData = this.taskCalendarService.filerTaskDataByParams({
            ...params,
            componentType: 'legend'
        }, this.periodChart.month)
        //подавление анимации выбора категории
        this.myChart.setOption({animation: false});
        this.myChart.dispatchAction({
            type: 'legendSelect',
            name: params.name
        });
        this.myChart.setOption({animation: true});
        let title = this.translate.instant('WIDGETS.CALENDAR_TASKS.LABEL.TASKS_FOR_MONTH') + params.name
        taskData?.length ? this.openTaskTableDialog(taskData, title) : null;
    }

    handleDiagramClick(params: TParamsCB) {
        let taskData = this.taskCalendarService.filerTaskDataByParams(params, this.periodChart.month)
        let title = this.translate.instant('WIDGETS.CALENDAR_TASKS.LABEL.TASKS_FOR_DATE') + taskData[0].due_time.slice(0, 10).split('-').reverse().join('-')
        taskData?.length ? this.openTaskTableDialog(taskData, title) : null;
    }

    openTaskTableDialog(taskData: TaskModel[], title: string) {
        this.dialogViewTaskRef = this.dialog.open(AppTasksViewCalendarComponent, DIALOG_VIEW_TASK_TABLE);
        this.dialogViewTaskRef.componentInstance.taskData = taskData;
        this.dialogViewTaskRef.componentInstance.title = title;
    }
}